import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface TenantTransfersState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: TenantTransfersState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    recoged_started_at: dayjs().startOf("day").toISOString(),
    recoged_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const tenantTransfersSelects = {
  loading: (state: RootState) => state.tenantTransfers.loading,
  dateRange: (state: RootState) => state.tenantTransfers.dateRange,
  queryParams: (state: RootState) => state.tenantTransfers.queryParams,
  transfers: (state: RootState) => state.tenantTransfers.transfers,
};

export const tenantTransfersThunks = {
  list: createAsyncThunk(
    "tenantTransfers/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list(params).run();
      return res.data.msg;
    },
  ),
};

export const tenantTransfersSlice = createSlice({
  name: "tenantTransfers",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantTransfersThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(tenantTransfersThunks.list.fulfilled, (state, action) => {
      state.loading = false;
      state.transfers = action.payload.transfers;
    });
    builder.addCase(tenantTransfersThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const tenantTransfersActions = tenantTransfersSlice.actions;
